import type { IssueViewModel } from '@trinnvis/dabih-api-client';
import { previousIsIssueProcessed } from './previous-is-issue-processed';
import { isEmptyOrInvalidString } from '../../../utilities/text';

export function isIssueProcessed(issue: IssueViewModel): boolean {
  if (issue.reportedDate && issue.reportedDate < '2024-08-23') {
    return previousIsIssueProcessed(issue);
  }

  if (issue.processedDate && issue.processedBy) {
    if (issue.requiresMeasures === false) {
      return true;
    }
    if (
      issue.requiresMeasures === true &&
      !isEmptyOrInvalidString(issue.identifiedMeasures) &&
      issue.implementedMeasure === true
    ) {
      /**
       * I.e. 'needs evaluation'
       */
      if (issue.evaluated === false) {
        return true;
      }
      if (issue.evaluated === true && issue.evaluatedBy && issue.evaluatedDate && issue.evaluatedOk === true) {
        return true;
      }
    }
  }
  return false;
}
